export default {
  moveToLeft: {
    out: 'moveToLeft',
    in: 'moveFromRight',
    opposite: 'moveToRight',
    carousel: true,
  },
  moveToRight: {
    out: 'moveToRight',
    in: 'moveFromLeft',
    opposite: 'moveToLeft',
  },
  moveToBottom: {
    out: 'moveToBottom',
    in: 'moveFromTop',
    opposite: 'moveToTop',
    vertical: true,
    carousel: true,
  },
  moveToTop: {
    out: 'moveToTop',
    in: 'moveFromBottom',
    opposite: 'moveToBottom',
    vertical: true,
    carousel: true,
  },
  fadeFromRight: {
    out: 'fade',
    in: 'moveFromRight ontop',
    opposite: 'fadeFromLeft',
    carousel: true,
  },
  fadeFromLeft: {
    out: 'fade',
    in: 'moveFromLeft ontop',
    opposite: 'fadeFromRight',
  },
  fadeFromBottom: {
    out: 'fade',
    in: 'moveFromBottom ontop',
    opposite: 'fadeFromTop',
    vertical: true,
    carousel: true,
  },
  fadeFromTop: {
    out: 'fade',
    in: 'moveFromTop ontop',
    opposite: 'fadeFromBottom',
    vertical: true,
    carousel: true,
  },
  fadeToLeft: {
    out: 'moveToLeftFade',
    in: 'moveFromRightFade',
    opposite: 'fadeToRight',
    carousel: true,
  },
  fadeToRight: {
    out: 'moveToRightFade',
    in: 'moveFromLeftFade',
    opposite: 'fadeToLeft',
  },
  fadeToTop: {
    out: 'moveToTopFade',
    in: 'moveFromBottomFade',
    opposite: 'fadeToBottom',
    vertical: true,
    carousel: true,
  },
  fadeToBottom: {
    out: 'moveToBottomFade',
    in: 'moveFromTopFade',
    opposite: 'fadeToTop',
    vertical: true,
    carousel: true,
  },
  differentEasingFromRight: {
    out: 'moveToLeftEasing ontop',
    in: 'moveFromRight',
    opposite: 'differentEasingFromLeft',
    carousel: true,
  },
  differentEasingFromLeft: {
    out: 'moveToRightEasing ontop',
    in: 'moveFromLeft',
    opposite: 'differentEasingFromRight',
  },
  differentEasingFromTop: {
    out: 'moveToBottomEasing ontop',
    in: 'moveFromTop',
    opposite: 'differentEasingFromBottom',
    vertical: true,
    carousel: true,
  },
  differentEasingFromBottom: {
    out: 'moveToTopEasing ontop',
    in: 'moveFromBottom',
    opposite: 'differentEasingFromTop',
    vertical: true,
    carousel: true,
  },
  cubeToLeft: {
    out: 'rotateCubeLeftOut ontop',
    in: 'rotateCubeLeftIn',
    opposite: 'cubeToRight',
    carousel: true,
  },
  cubeToRight: {
    out: 'rotateCubeRightOut ontop',
    in: 'rotateCubeRightIn',
    opposite: 'cubeToLeft',
  },
  cubeToTop: {
    out: 'rotateCubeTopOut ontop',
    in: 'rotateCubeTopIn',
    opposite: 'cubeToBottom',
    vertical: true,
    carousel: true,
  },
  cubeToBottom: {
    out: 'rotateCubeBottomOut ontop',
    in: 'rotateCubeBottomIn',
    opposite: 'cubeToTop',
    vertical: true,
    carousel: true,
  },
  carouselToLeft: {
    out: 'rotateCarouselLeftOut ontop',
    in: 'rotateCarouselLeftIn',
    opposite: 'carouselToRight',
    carousel: true,
  },
  carouselToRight: {
    out: 'rotateCarouselRightOut ontop',
    in: 'rotateCarouselRightIn',
    opposite: 'carouselToLeft',
  },
  carouselToTop: {
    out: 'rotateCarouselTopOut ontop',
    in: 'rotateCarouselTopIn',
    opposite: 'carouselToBottom',
    vertical: true,
    carousel: true,
  },
  carouselToBottom: {
    out: 'rotateCarouselBottomOut ontop',
    in: 'rotateCarouselBottomIn',
    opposite: 'carouselToTop',
    vertical: true,
    carousel: true,
  },
}
